import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Costanti } from 'app/main/utils/costanti';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NppWebinarHistoryResponse, NppWebinarResponse } from '../interfaces/npp-webinar.interfaces';

@Injectable({
  providedIn: 'root'
})
export class NppWebinarService {
  private BASEURL = Costanti.NPP_APIURL + 'npp/webinar/';
  private liveVideoSubject = new BehaviorSubject<NppWebinarResponse>(null);

  liveVideo$ = this.liveVideoSubject.asObservable();

  constructor(private http: HttpClient) {}

  getLiveVideo(): Observable<NppWebinarResponse> {
    return this.http.get(this.BASEURL + 'live-video').pipe(
      map((res: any) => {
        const data = res && res.data ? res.data : {};
        const videos = Array.isArray(data.videos) ? data.videos : [];
        return {
          isLive: !!data.isLive || videos.length > 0,
          videos: videos
        };
      })
    );
  }

  caricaStatoWebinarLive(): void {
    this.getLiveVideo().subscribe(
      response => this.liveVideoSubject.next(response),
      () => this.liveVideoSubject.next({ isLive: false, videos: [] })
    );
  }

  getHistory(page: number, limit: number, search: string): Observable<NppWebinarHistoryResponse> {
    const safePage = page && page > 0 ? page : 1;
    const safeLimit = limit && limit > 0 ? limit : 6;
    let url = `${this.BASEURL}storico?page=${safePage}&limit=${safeLimit}`;

    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    return this.http.get(url).pipe(
      map((res: any) => {
        const data = res && res.data ? res.data : {};
        const pagination = data.pagination || {};
        return {
          videos: Array.isArray(data.videos) ? data.videos : [],
          pagination: {
            page: pagination.page || safePage,
            limit: pagination.limit || safeLimit,
            total: pagination.total || 0,
            totalPages: pagination.totalPages || 0
          }
        };
      })
    );
  }

  sincronizza(): Observable<void> {
    return this.http.post<void>(this.BASEURL + 'sincronizza', {});
  }
}
